const apiMethods = {
    CENTERS: '/centers',
    JURISDICTIONS: '/jurisdictions',
    JURISDICTIONS_SLUG: '/jurisdictions/slug',
    JURISDICTIONS_USER: '/user/jurisdictions',
    UNITS: '/units',
    TYPES: '/types',
    STATES: '/states',
    USER_DATA: '/user',
    PROCEEDING: '/proceedings',
    HISTORY: '/proceedings/history',
    DECODE_URL: '/proceedings/decode-url',
    HISTORY_LINK: '/proceedings/history/link',
    MY_PROCEEDINGS: '/user/proceedings',
    HISTORY_TEXT_DOWNLOAD: '/proceedings/history/text/download',
    HISTORY_FLIPBOOK: '/proceedings/history/flipbook'
};

export default apiMethods;